export const generateActions = prefix => ([ `${prefix}/START`, `${prefix}/SUCCESS`, `${prefix}/FAILURE` ])



// WEBPACK FOOTER //
// ./src/store/utils.js